<template>
    <div>

        <modal name="historyTransaksi" id="historyTransaksi" :draggable="false" :scrollable="true" :height="'auto'">
            <div class="modal fade show modal-transaksi " tabindex="-1" style="display: block;margin-top: 2%;"
                aria-modal="true" role="dialog">
                <div class="modal-dialog  modal-xl">
                    <div class="modal-content">

                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel"> {{ this.docNo }} </h5>
                            <button type="button" class="btn btn-default" @click.prevent="removeModals()"
                                aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body">
                            <div v-show="this.isLoading">
                                <div class="loader"></div>
                                <div class="loadertext"> {{ $t('loadingTxt') }}...</div>
                            </div>
                            <div v-show="!this.isLoading">
                                <ul class="nav nav-tabs nav-tabs-line" id="lineTab" role="tablist">

                                    <li class="nav-item">
                                        <a class="nav-link active" id="riwayat-status-line-tab" data-bs-toggle="tab"
                                            href="#riwayat-status" role="tab" aria-controls="disabled"
                                            aria-selected="false">
                                            Riwayat Status </a>
                                    </li>

                                    <li class="nav-item">
                                        <a class="nav-link" id="riwayat-respon-line-tab" data-bs-toggle="tab"
                                            href="#riwayat-respon" role="tab" aria-controls="disabled"
                                            aria-selected="false">
                                            Riwayat Respon </a>
                                    </li>

                                    <li class="nav-item">
                                        <a class="nav-link" id="document-line-tab" data-bs-toggle="tab" href="#document"
                                            role="tab" aria-controls="disabled" aria-selected="false"> Detail Dokumen
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="riwayat-petugas-line-tab" data-bs-toggle="tab"
                                            href="#riwayat-petugas" role="tab" aria-controls="disabled"
                                            aria-selected="false">
                                            Riwayat Petugas </a>
                                    </li>

                                </ul>

                                <div class="tab-content mt-3" id="lineTabContent">
                                    <div class="tab-pane fade show active" id="riwayat-status" role="tabpanel"
                                        aria-labelledby="riwayat-status-line-tab">

                                        <ul v-show="riwayatResponse.length > 0" class="timeline"
                                            style="background: none;padding: 10px; max-width: 70%;">
                                            <!-- <li class="event" style="padding-bottom:0px">
                                            <p>Jumat, 23 Februari 2024 pukul 06.42 - Payment Verification - SYSTEM</p>
                                        </li>
                                        <li class="event" style="padding-bottom:0px">
                                            <p>Jumat, 23 Februari 2024 pukul 06.42 - Payment Verification - SYSTEM</p>
                                        </li> -->
                                            <li v-for="(item) in riwayatResponse" :key="item.document_history_id"
                                                class="event" style="padding-bottom:0px">
                                                <p>{{ item.created_at }} - {{ item.remarks }} - {{ item.created_by }}</p>
                                            </li>
                                        </ul>
                                        <div class="row" style="text-align: center;" v-show="!riwayatResponse.length > 0">
                                            <p>Empty Data</p>
                                        </div>
                                    </div>

                                    <div class="tab-pane fade show" id="riwayat-respon" role="tabpanel"
                                        aria-labelledby="riwayat-respon-line-tab">
                                        <vue-good-table title="list-entitas" :rows="rowsRespon" :columns="columnsRespon"
                                            :line-numbers="true" :isLoading="isLoading">
                                            <div slot="emptystate">
                                                Empty Row
                                            </div>
                                            <template slot="table-row" slot-scope="props">
                                                <span v-if="props.column.field == 'actions'">
                                                    <a href="#" title="Detail">
                                                        <i class="mdi mdi-eye" style="font-size:16px"></i>
                                                    </a>

                                                    <a href="#" title="Info" @click.prevent="detailRespon(props.row)">
                                                        <i class="mdi mdi-information-outline"
                                                            style="font-size:16px;color:#66d1d1;"></i>
                                                    </a>
                                                    <a href="#" title="Muat Ulang">
                                                        <i class="mdi mdi-arrow-u-right-top text-warning"
                                                            style="font-size:16px;"></i>
                                                    </a>
                                                </span>
                                                <span v-else>
                                                    {{ props.formattedRow[props.column.field] }}
                                                </span>
                                            </template>
                                        </vue-good-table>
                                    </div>
                                    <div class="tab-pane fade show" id="document" role="tabpanel"
                                        aria-labelledby="document-line-tab">
                                        <iframe :src="getPdfEndpoint" frameborder="0" width="100%" height="1000px" ></iframe>
                                    </div>
                                    <div class="tab-pane fade show" id="riwayat-petugas" role="tabpanel"
                                        aria-labelledby="riwayat-petugas-line-tab">
                                        <vue-good-table title="list-entitas" :rows="rowsPetugas" :columns="columnsPetugas"
                                            :line-numbers="true" :isLoading="isLoading">
                                            <div slot="emptystate">
                                                Empty Row
                                            </div>
                                        </vue-good-table>
                                    </div>
                                </div>


                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">Batal</button>
                        </div>

                    </div>
                </div>
            </div>
        </modal>

        <div ref="modal" class="modal fade" :class="{ show: showModalRespon, 'd-block': showModalRespon }" tabindex="-1"
            role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{ titleDetailRespon }}</h4>
                    </div>
                    <div class="modal-body">
                        <vue-good-table title="list-detail-respons" :rows="rowsResponDetail" :columns="columnsResponDetail"
                            :line-numbers="true" :isLoading="isLoading">
                            <div slot="emptystate">
                                Empty Row
                            </div>
                        </vue-good-table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary"
                            @click.prevent="showModalRespon = false">Batal</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "modalHistoryDocument",
    props: {
        idDocument: Number
    },
    data() {
        return {
            showModalRespon: false,
            lastId: null,
            isLoading: false,
            docNo: null,
            rowsRespon: [],
            columnsRespon: [
                {
                    label: "Waktu Respon",
                    field: 'created_at',
                    type: 'text',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: "Uraian Respon",
                    field: 'uraian_response',
                    type: 'text',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: "Action",
                    field: 'actions',
                    type: 'text',
                    thClass: 'text-center',
                },
            ],
            rowsPetugas: [],
            columnsPetugas: [
                {
                    label: "Nama",
                    field: 'nama',
                    type: 'text',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: "NIP",
                    field: 'nip',
                    type: 'text',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: "Otoritas",
                    field: 'otoritas',
                    type: 'text',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: "Waktu Tunjuk",
                    field: 'waktu_tunjuk',
                    type: 'text',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: "Waktu Rekam",
                    field: 'created_at',
                    type: 'text',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
            ],
            riwayatResponse: [],

            titleDetailRespon: "",
            rowsResponDetail: [],
            columnsResponDetail: [
                {
                    label: "Npwp",
                    field: 'npwp',
                    type: 'text',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: "Nama",
                    field: 'nama',
                    type: 'text',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: "Kode Billing",
                    field: 'kode_billing',
                    type: 'text',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: "Nomor Aju",
                    field: 'nomor_aju',
                    type: 'text',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: "Total Bayar",
                    field: 'total_bayar',
                    type: 'text',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
            ],

        }
    },
    methods: {
        detailRespon(row) {
            if (row.detail && row.detail.length > 0) {
                this.showModalRespon = true;
                this.titleDetailRespon = row.uraian_response;
                this.rowsResponDetail = row.detail;
            } else {
                this.error("Empty Detail");
            }
        },
        removeModals() {
            this.$emit("closeModal");
        },
        loadDetail(id) {

            const baseURI = this.$settings.endPointCeisa + "v1/document/detail/" + id;

            return this.$http.get(baseURI, { timeout: 100000 }).then((response) => {
                this.docNo = response.data.datas.nomorAju;
                this.riwayatResponse = response.data.datas.history;
                this.rowsPetugas = response.data.datas.history_petugas;
                this.rowsRespon = response.data.datas.history_reponse;
                this.isLoading = false;
            }).catch(error => {

                this.isLoading = false;

                if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
                } else {

                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else {
                            this.$router.push('/page-not-found');
                        }
                    }

                }

            });

        },
        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.isLoading = false;
            }, 1000); // hide the message after 3 seconds
        },

    },
    watch: {
        idDocument: function (newVal) {
            if (newVal) {
                if (this.lastId !== newVal) {
                    this.isLoading = true;
                    this.docNo = null;
                    this.rowsRespon = [];
                    this.rowsPetugas = [];
                    this.riwayatResponse = [];
                    this.lastId = newVal;
                    this.loadDetail(newVal);
                }
            }
        },
    },
    computed:{
        getPdfEndpoint(){
            var a = "";
            if(this.idDocument && this.idDocument > 0){
                a = this.$settings.endPointCeisa+'generate-pdf/'+this.idDocument;
            }
            return a;
        }
    }
}
</script>


<style scoped>
.modal {
    background: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background: #fff;
    border-radius: 0px;
    border: none;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    padding: 0px;
    width: 100%;
    height: 100%;
    margin-left: 0px !important;
}
</style>